export function ucfirst(s: string): string {
  return s.length ? s[0].toUpperCase() + s.substring(1) : ''
}

export function capitalize(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export function capitalizeLetters(s: string) {
  return s.replace(/\b[a-z]/g, match => match.toUpperCase())
}
